import type {ComponentType} from 'react';
import {Plug, BookOpen, SlidersHorizontal} from 'lucide-react';

export type RelayConfigSectionId =
  | 'connections'
  | 'knowledge'
  | 'configuration';

export type RelayConfigSection = {
  id: RelayConfigSectionId;
  label: string;
  description: string;
  icon: ComponentType<{className?: string}>;
};

export const RELAY_CONFIG_SECTIONS: RelayConfigSection[] = [
  {
    id: 'knowledge',
    label: 'Organization Knowledge',
    description: 'Context used by categorization and Otto chat.',
    icon: BookOpen,
  },
  {
    id: 'configuration',
    label: 'Configuration',
    description: 'Rules for confirming threads and organizing files.',
    icon: SlidersHorizontal,
  },
  {
    id: 'connections',
    label: 'Connections',
    description: 'Mailbox connections and the sender domain allowlist.',
    icon: Plug,
  },
];

export const DEFAULT_RELAY_CONFIG_SECTION: RelayConfigSectionId = 'knowledge';

export const RELAY_CONFIG_PATH = '/admin/relay-config';

/**
 * Resolve a raw ``?section=`` query value to a known section id,
 * falling back to the default when absent or invalid.
 */
export function resolveRelayConfigSection(
  value: string | undefined | null
): RelayConfigSectionId {
  return RELAY_CONFIG_SECTIONS.some((section) => section.id === value)
    ? (value as RelayConfigSectionId)
    : DEFAULT_RELAY_CONFIG_SECTION;
}
